import { UPDATE_ANCILLARIES } from '../actions/ancillaries'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  holdLuggage15: {
    key: '5B15',
    value: 0,
    labelId: 'B15 hold luggage',
    icon: 'medium-luggage',
  },
  holdLuggage20: {
    key: '5B20',
    value: 0,
    labelId: 'B20 hold luggage',
    icon: 'medium-luggage',
  },
  GOLF: {
    key: 'GOLF',
    value: 0,
    labelId: 'Golfing Equipment',
    icon: 'golf',
  },
  SKIS: {
    key: 'SKIS',
    value: 0,
    labelId: 'Winter sport equipment',
    icon: 'wintersport',
  },
}

function ancillaries(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_ANCILLARIES:
      return {
        ...action.data,
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default ancillaries
